// Contact component
// Kontakt forma je maknuta jer backend (send-email) više ne postoji.
// Upiti idu preko emaila, telefona ili WhatsApp gumba.

const Contact = () => (
    <section id="contact">
        <div className="inner">
            <section>
                <h2>Javite nam se</h2>
                <p>
                    Za upite i rezervacije termina javite nam se emailom, telefonom ili putem WhatsAppa.
                    Rado ćemo odgovoriti na sva pitanja.
                </p>
                <ul className="actions">
                    <li>
                        <a href="mailto:dzunglarodendaonica@gmail.com" className="button primary">Pošalji email</a>
                    </li>
                    <li>
                        <a href="https://wa.me/385915961090" target="_blank" rel="noopener noreferrer" className="button">WhatsApp</a>
                    </li>
                </ul>
            </section>
            <section className="split">
                <section>
                    <div className="contact-method">
                        <span className="icon solid alt fa-envelope"></span>
                        <h3>Email</h3>
                        <a href="mailto:dzunglarodendaonica@gmail.com">dzunglarodendaonica@gmail.com</a>
                    </div>
                </section>
                <section>
                    <div className="contact-method">
                        <span className="icon solid alt fa-phone"></span>
                        <h3>Telefon</h3>
                        <span>univ. mag. praesc. educ. Lucija Raguž</span><br/>
                        <a href="tel:+385915961090">(+385) 91 596 1090</a>
                    </div>
                </section>
                <section>
                    <div className="contact-method">
                        <span className="icon solid alt fa-home"></span>
                        <h3>Adresa</h3>
                        <a href="https://maps.app.goo.gl/C58HqzGoq1UjY3xx5" target="_blank" rel="noreferrer">
                            Rakarska 72A<br/>
                            Velika Gorica<br/>
                            Hrvatska, 10410
                        </a>
                    </div>
                </section>
            </section>
        </div>
    </section>
);

export default Contact;
